import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ✅ 브라우저 스크롤 복원 설정 (뒤로가기 시 원래 위치로)
if (window.history.scrollRestoration) {
  window.history.scrollRestoration = 'auto';
}

// ✅ 에러 필터링
const originalError = console.error;
console.error = function(...args) {
  const errorString = args.join(' ');
  if (errorString.includes('placeholder') || 
    errorString.includes('ERR_NAME_NOT_RESOLVED') ||
    errorString.includes('via.placeholder')) {
    return;
  }
  originalError.apply(console, args);
};

const rootElement = document.getElementById('root');

// 🔥 React-Snap 지원
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(
    rootElement,
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </React.StrictMode>
  );
}

reportWebVitals();